import {useContext, useState} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import Search from '../../../../components/Search'
import {SalesRepReportContext} from '../../context'
import Import from '../../../../images/Import.png'
import moment from 'moment'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import {MIN_DATE_RANGE, dataToSalesRepShippingCSV} from '../../utils'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'

const SalesRepReportHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {
    onSalesRepSearch,
    handleSalesRepReportDateChange,
    salesRepData,
    salesRepTypes,
    isSalesRepDropdownLoading,
    onChangeSalesRepTypeFilter,
  } = useContext(SalesRepReportContext)
  const [isLoading, setIsLoading] = useState(false)

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToSalesRepShippingCSV(salesRepData)
    if (data?.length) {
      SampleCSVDownload(data || [], `Shipping_Sales_Rep_Report_Report_${formattedDateTime}`)
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex flex-wrap justify-content-between align-items-end mb-10'>
      <div className='d-flex gap-10 align-items-end'>
        <Search onSearch={onSalesRepSearch} />
        <MultiSelect
          id={`sales-rep-filter`}
          label='Sales Rep Type'
          options={salesRepTypes}
          className='w-200px'
          placeholder='Select Sales Rep Type'
          allValuesSelectedText={'Sales Rep Type: All'}
          isLoading={isSalesRepDropdownLoading}
          handleSelected={onChangeSalesRepTypeFilter}
        />
      </div>
      <div className='d-flex gap-5'>
        <button
          className='btn btn-outline'
          onClick={handleDownLoadCSV}
          disabled={isLoading || !salesRepData?.length}
        >
          <div className='d-flex align-items-center'>
            <img src={Import} alt='Import File' className='me-2 import-icon' />
            <div className='d-flex align-items-center'>
              {isLoading ? 'Downloading...' : 'Export CSV'}
              {isLoading && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </div>
          </div>
        </button>
        <PredefinedDateRange
          cb={handleSalesRepReportDateChange}
          defaultValue={dateRangeLabel || 'Last 90 Days'}
          includeCurrantDay={true}
          startDate={MIN_DATE_RANGE}
        />
      </div>
    </div>
  )
}
export {SalesRepReportHeader}
